import { call, put, takeLatest } from "redux-saga/effects";
import { thongKeSoLuongSinhVienApi } from "../../../api/bao-cao/thongKeSoLuongSinhVienApi";
import { Download, fileNameWithTime } from "../../../helpers/download";
import { NotifyHelper } from "../../../helpers/toast";
import { IThongKeSoLuongSinhVienRequest } from "../../../model/request/bao-cao/IThongKeSoLuongSinhVienRequest";
import { IThongKeSoLuongSinhVienKetQua } from "../../../model/respone/bao-cao/IThongKeSoLuongSinhVien";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eThongKeSoLuongSinhVienActionIds,
  IThongKeSoLuongSinhVienActionTypes,
} from "../../action-types/bao-cao/IThongKeSoLuongSinhVienActions";
import { rootActions } from "../../actions/rootActions";

const mainAction = rootActions.baoCao.thongKeSoLuongSinhVien;

export function* thongKeSoLuongSinhVienSaga(): any {
  yield takeLatest(eThongKeSoLuongSinhVienActionIds.LOAD_START, loadWorker);
  yield takeLatest(
    eThongKeSoLuongSinhVienActionIds.EXPORT_EXCEL_START,
    exportWorker,
  );
  yield takeLatest(
    eThongKeSoLuongSinhVienActionIds.XEM_TRUOC_START,
    xemTruocWorker,
  );
}

function* loadWorker(action: IThongKeSoLuongSinhVienActionTypes): any {
  const res: IBaseRespone = yield call(
    thongKeSoLuongSinhVienApi.Select,
    action.payload as IThongKeSoLuongSinhVienRequest,
  );
  if (res.is_success) {
    yield put(
      mainAction.LOAD_SUCCESS(res.data as IThongKeSoLuongSinhVienKetQua),
    );
  } else {
    yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi"));
    NotifyHelper.Error(res.message ?? "Có lỗi");
  }
}

function* exportWorker(action: IThongKeSoLuongSinhVienActionTypes): any {
  const request = action.payload as IThongKeSoLuongSinhVienRequest;
  // Lớp phủ "đang xử lý": biểu gom cả trường chạy lâu, không có nó người dùng tưởng treo.
  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(true));
  try {
    const res: IBaseRespone = yield call(
      thongKeSoLuongSinhVienApi.ExportExcel,
      request,
    );
    if (res.is_success) {
      Download.Excel(
        res.data as string,
        `${fileNameWithTime(
          `Thong ke so luong sinh vien HK${request.hoc_ky} ${request.nam_hoc}`,
          "Thống kê số lượng sinh viên",
        )}.xlsx`,
      );
      yield put(mainAction.EXPORT_EXCEL_SUCCESS(""));
    } else {
      yield put(mainAction.EXPORT_EXCEL_ERROR(res.message ?? "Có lỗi"));
      NotifyHelper.Error(res.message ?? "Có lỗi");
    }
  } finally {
    // finally: hỏng giữa chừng (mất mạng, hết phiên) cũng phải gỡ lớp phủ.
    yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
  }
}

function* xemTruocWorker(action: IThongKeSoLuongSinhVienActionTypes): any {
  yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(true));
  try {
    const res: IBaseRespone = yield call(
      thongKeSoLuongSinhVienApi.XemTruoc,
      action.payload as IThongKeSoLuongSinhVienRequest,
    );
    if (res.is_success) {
      yield put(mainAction.XEM_TRUOC_SUCCESS(res.data as string));
    } else {
      yield put(mainAction.XEM_TRUOC_ERROR(res.message ?? "Có lỗi"));
      NotifyHelper.Error(res.message ?? "Có lỗi");
    }
  } finally {
    yield put(rootActions.common.layout.SHOW_HIDE_LOADING_PAGE(false));
  }
}
